import { createFileRoute, redirect } from '@tanstack/react-router'
import { getDefaultStore } from 'jotai'
import { isAuthenticatedAtom, sessionAtom, waitForAuthInit } from '@/store/auth.atom'
import { ChangePasswordPage } from '@/pages/auth/ChangePasswordPage'

export const Route = createFileRoute('/(public)/password')({
    beforeLoad: async () => {
        if (typeof window === 'undefined') return

        await waitForAuthInit()

        const store = getDefaultStore()
        const isAuthenticated = store.get(isAuthenticatedAtom)
        const session = store.get(sessionAtom)

        if (!isAuthenticated) {
            throw redirect({
                to: '/login',
            })
        }

        if (session?.user.loginCount !== 0) {
            throw redirect({
                to: '/dashboards',
            })
        }
    },
    component: ChangePasswordPage,
})